<script>
import { mapGetters } from 'vuex';
import DesktopWarning from '@/components/ui/DesktopWarning';
import LandscapeWarning from '@/components/ui/LandscapeWarning';
import Preloader from '@/components/ui/Preloader';
import HeaderONF from '@/components/ui/HeaderONF';
import Bubbles from '@/components/ui/Bubbles';
import config from '@/config';

const debug = process.env.NODE_ENV === 'development';

export default {
  name: 'TheApp',
  components: {
    DesktopWarning,
    LandscapeWarning,
    HeaderONF,
    Bubbles,
    Preloader,
  },
  computed: {
     ...mapGetters({
      isMobile: 'App/isMobile',
      isAppReady: 'App/ready',
      skipTo: 'App/skipTo',
      locale: 'I18n/locale',
    }),
  },
  data () {
    return {
    }
  },
  mounted() {
    const locale = document.location.hostname.indexOf("bubble") != -1 ? config.LOCALES.EN : config.LOCALES.FR;
    this.$store.dispatch("App/INIT", locale);

    if(debug) this.useKeyboard();
    
    const skipRoutes = (debug && this.$route.query.skip) ? this.$route.query.skip : null;
    if(skipRoutes) {
      this.$store.commit('App/SKIP_TO', skipRoutes)  
    }

    window.addEventListener("visibilitychange", () => {
      this.$store.dispatch('Sound/MUTE', document.visibilityState === 'hidden' || document.visibilityState === false);
    });
  },
  methods: {
    useKeyboard() {
      const routes = [
          {name:'Intro' },
          {name: `BeforeEnter${this.locale.toUpperCase()}`},
          {name:"Prelude", params: { id:"born" }},
          {name:`Born${this.locale.toUpperCase()}`},
          {name:"Prelude", params: { id:"smog" }},
          {name:`Smog${this.locale.toUpperCase()}`},
          {name:"Prelude", params: { id:"meteo" }},
          {name:`Meteo${this.locale.toUpperCase()}`},
          {name:"Prelude", params: { id:"heat" }},
          {name:`Heat${this.locale.toUpperCase()}`},
          {name:"Prelude", params: { id:"death" }},
          {name:`Death${this.locale.toUpperCase()}`},
          {name:`About${this.locale.toUpperCase()}`},
        ];

      window.addEventListener("keyup", (event) => {
        if(event.keyCode == 39 && event.shiftKey) {
          let nextRoute;
          
          routes.forEach((route, index) => {
            if(this.skipTo) {
              if(route.name === this.skipTo + this.locale.toUpperCase()) {
                nextRoute = routes[index];
              }
            }
            else{
              if(this.$route.name === route.name && index < routes.length - 1) {
                if(!route.params || (route.params && this.$route.params.id === route.params.id)) {
                  nextRoute = routes[index+1];
                }
              }
            }
          });

          if(nextRoute) {
            this.$store.dispatch('Sound/STOP', {id:'tic', all:true});
            this.$router.push(nextRoute);
          }
        }

        if(event.keyCode === 37 && event.shiftKey) {
          this.$router.go(-1);
        }
      });
    }
  }
}
</script>

<template>
  <div id="app">
      <desktop-warning v-if="!isMobile" />
      <template v-if="isMobile">
        <HeaderONF />
        <bubbles />
        <preloader ref="preloader" v-if="!isAppReady" />
        <router-view class="router" ref="View" v-if="isAppReady" />
        <landscape-warning />
      </template>
  </div>
</template>

<style lang="scss">

/** GLOBAL ***/
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}

html {
  height: 100%;
  font-size: 0.9rem;
  line-height: 1.3;

  @include ipad {
    font-size: 1.3rem;
  }
}

body {
  font-size: 100%;
  height: 100%;
  background-color: $c-daintree;
  color: $c-black;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

/** APPLICATION ***/
#app {
  background-color: $c-daintree;
  width:100%;
  height:100%;
  margin: 0;
  padding: 0;
  font-family: $ff-double-medium;
}
</style>
